<template>
    <div class="mice-page">
        <header class="headerer_ra">
            <a class="link-home external"
               href="https://mobile.rcclchina.com.cn/">返回首页</a>
            <div class="dailog">
                <div class="contact-text"
                     @click="isShowContact = !isShowContact">
                    联系我们
                </div>
                <div class="contact-pop"
                     v-show="isShowContact">
                    <img :src="require('@/assets/mice/dailog1.png')"
                         alt="" />
                    <a href="tel:021-25011777"
                       class="tel"></a>
                </div>
            </div>
            <div class="quote"
                 @click="scrolltoForm">企业团队询价</div>
        </header>
        <div class="racontainer">
            <div class="bottomnav">
                <div class="nav active">
                    <a href="/mice">
                        <div class="pos">
                            <div>
                                <img :src="require('@/assets/mice/nav1.jpg')" />
                                <img :src="require('@/assets/mice/nav1_1.jpg')"
                                     class="img" />
                            </div>
                        </div>
                    </a>
                </div>
                <div class="nav nav2"
                     @click="isShowShips = !isShowShips">
                    <div class="pos">
                        <div>
                            <img :src="require('@/assets/mice/nav2.jpg')"
                                 class="img1" />
                            <img :src="require('@/assets/mice/nav2_1.jpg')"
                                 class="img" />
                        </div>
                    </div>
                </div>
                <div class="nav">
                    <a href="https://mobile.rcclchina.com.cn/campaign/mice/itinerary.html">
                        <div class="pos">
                            <div>
                                <img :src="require('@/assets/mice/nav3.jpg')" />
                                <img :src="require('@/assets/mice/nav3_1.jpg')"
                                     class="img" />
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div v-if="isShowShips"
                 class="select">
                <a href="https://mobile.rcclchina.com.cn/campaign/mice/SC.html">
                    <div>海洋光谱号</div>
                </a>
            </div>
            <div v-show="isShowPlan"
                 class="popPlan">
                <div class="pos">
                    <img :src="require('@/assets/mice/back.jpg')" />
                    <div class="btn_back"
                         @click="hidePlan"></div>
                </div>
                <div class="plan">
                    <h2>皇家加勒比游轮优先合作伙伴计划</h2>
                    <p>
                        该计划旨在使上市和私营公司，通过向其员工提供我们指定航次的游轮折扣，让员工享受更多福利。
                    </p>
                    <h2>加入计划可享受的福利</h2>
                    <p>
                        加入计划后贵司员工在预订皇家指定航次舱房，不仅可以在船票零售指导价（不含港务税费及游轮服务费）的基础上享受“品牌促销”及/或“闪惠”（如有如适用），
                        而且可以进一步享受游轮公司给予贵司员工额外10%的折扣。
                    </p>
                    <h2>计划包含航线</h2>
                    <p>指定皇家加勒比游轮中国母港航次及海外航次。</p>
                    <h2>计划船票预订政策</h2>
                    <p>
                        申请加入计划的公司须有自己公司邮箱域名以便进行认证。所有加入计划后折扣价购买的船票仅限贵司员工及其直系亲属使用，不得宣传、推广、销售给任何其他实体或个人。同一人最多可在同一航次上预订不超过7间舱。除船票部分折扣外，港务税费，小费，岸上观光，取消政策与官网该航次个人预订政策相同。<br />*
                        详情以具体政策为准。
                    </p>
                    <h2>如何帮助公司加入计划</h2>
                    <p>
                        1.欢迎您直接致电我们<span>021-25011777</span>或邮件发送至<span>mice@rcclapac.com</span><br />2.填写表格提交后，我们会尽快与您联系
                    </p>
                </div>
            </div>

            <!--视频弹框-->
            <div v-if="isShowVideo"
                 class="popVideo"
                 id="videoContainer">
                <div class="content">
                    <video src="https://resource.rcclchina.com.cn/42/mice/video/MICE%2020240801%20updated.mp4"
                           preload="auto"
                           controls="controls"
                           x-webkit-airplay="true"
                           x5-playsinline="true"
                           webkit-playsinline="true"
                           playsinline="true"
                           autoplay
                           id="myvideo"></video>
                    <img src="https://resource.rcclchina.com.cn/42/gentuanfeb/images/close.png"
                         class="close"
                         @click="isShowVideo = false" />
                </div>
            </div>

            <div class="home">
                <div class="kv">
                    <Swiper ref="bannerSwiper"
                            :options="swiperOptions"
                            class="swiper-kv">
                        <SwiperSlide v-for="(item, i) in banners"
                                     :key="i"
                                     class="swiper-slide">
                            <img :src="item" />
                        </SwiperSlide>
                        <div ref="swiper-pagination"
                             class="swiper-pagination"
                             slot="pagination"></div>
                    </Swiper>
                </div>
                <div class="kv2">
                    <div class="swiper-container swiper-kv2">
                        <Swiper :options="shipSwiperOptions">
                            <SwiperSlide v-for="(item, i) in 3"
                                         :key="i"
                                         class="swiper-slide">
                                         <img :src="require('@/assets/mice/homekv2-2.jpg')" />
                                         <a href="https://mobile.rcclchina.com.cn/campaign/mice/SC.html">了解详情</a>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>

                <div class="videobox">
                    <div id="myvideo"
                         class="myvideo">
                        <div id="thePlayer1"></div>
                    </div>
                    <div class="btn_play"
                         @click="isShowVideo = true">
                        <img :src="require('@/assets/mice/video.jpg')" />
                    </div>
                </div>
                <div class="txt">
                    <div>
                        <h2>皇家超凡会奖</h2>
                        <p>
                            让您的团队为之欢呼雀跃的回忆及奖励旅游目的地。拥有着游轮行业先进多媒体及网络技术的会务场地，丰富创意的团队活动设施，精彩纷呈的演出以及无限饕餮美食，满足您的多方面活动需求。
                        </p>
                    </div>
                </div>
                <div class="pr">
                    <img :src="require('@/assets/mice/downimg.jpg')" />
                    <p>
                        <span>皇家游轮活动策划书</span>
                        <a class="download"
                           href="https://mobile.rcclchina.com.cn/campaign/mice/pdf/hjylhdchs.pdf"
                           download="皇家游轮活动策划书.pdf"
                           target="_blank">点击下载</a>
                    </p>
                </div>
                <img :src="require('@/assets/mice/line.jpg')" />
                <div class="partner">
                    <div class="box">
                        <div class="formlist">
                            <h2>团队报价需求填写</h2>
                            <p class="partTip"
                               @click="showPlan">
                                皇家加勒比游轮优先合作伙伴计划？
                            </p>
                            <div class="group">
                                <label><span class="required">*</span>公司全称</label>
                                <input type="text"
                                       v-model.trim="formData.companyName"
                                       placeholder="(必填)"
                                       name="company" />
                            </div>
                            <div class="group">
                                <label><span class="required">*</span>联系人</label>
                                <input type="text"
                                       v-model.trim="formData.contactName"
                                       placeholder="(必填)"
                                       name="username" />
                            </div>
                            <div class="group">
                                <label><span class="required">*</span>手机号</label>
                                <input type="tel"
                                       maxlength="11"
                                       v-model.trim="formData.contactTelephone"
                                       placeholder="(必填)"
                                       name="mobile" />
                            </div>
                            <div class="group">
                                <label><span class="required">*</span>邮箱</label>
                                <input type="text"
                                       v-model.trim="formData.contactEmail"
                                       placeholder="(必填)"
                                       name="email" />
                            </div>
                            <div class="group">
                                <label>职务</label>
                                <input type="text"
                                       v-model.trim="formData.jobTitle"
                                       placeholder="职务"
                                       name="position" />
                            </div>
                            <div class="group">
                                <label><span class="required">*</span>活动日期</label>
                                <input type="date"
                                       v-model="formData.meetingDate"
                                       :min="minDate"
                                       placeholder="(必填)" />
                            </div>
                            <div class="group">
                                <label>会议时长（几晚）</label>
                                <input type="number"
                                       v-model="formData.meetingDurationInNights"
                                       min="1"
                                       placeholder=""
                                       @input="handleNumberInput('meetingDurationInNights',)"
                                       />
                            </div>
                            <div class="group">
                                <label><span class="required">*</span>房间数量</label>
                                <input type="number"
                                       v-model="formData.roomCount"
                                       min="1"
                                       placeholder="(必填)"
                                       @input="handleNumberInput('roomCount')"
                                       />
                            </div>
                            <div class="group">
                                <label>会议类型</label>
                                <select v-model="formData.meetingType"
                                        class="form-select">
                                    <option v-for="(item, index) in meetingTypeOptions"
                                            :value="item.value"
                                            :key="index">
                                        {{ item.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="group">
                                <label>你是怎么知道我们的？</label>
                                <select v-model="formData.leadSource"
                                        class="form-select">
                                    <option v-for="(item, index) in leadSourceOptions"
                                            :value="item.value"
                                            :key="index">
                                        {{ item.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="group">
                                <label>你想去哪里？</label>
                                <input type="text"
                                       v-model.trim="formData.desiredDestination"
                                       placeholder="" />
                            </div>
                            <div class="group">
                                <label>上传RFP文件</label>
                                <input type="file"
                                       @change="handleFileUpload"
                                       accept=".pdf,.doc,.docx" 
                                       ref="rfpFileInput"
                                       />
                            </div>
                            <div class="group">
                                <label>备注</label>
                                <input type="text"
                                       v-model.trim="formData.remark"
                                       name="remark" />
                            </div>
                            <p>
                                <span @click="handleSelect"
                                      style="cursor: pointer"><i class="checkbox"
                                       :class="{ selected: isAgree }"></i>我已阅读并同意</span><a
                                   href="https://mobile.rcclchina.com.cn/Rccl.UserCenter/Privacy"
                                   target="_blank">*《隐私政策》*</a>
                            </p>
                                 <div class="submit"
                                 id="sendCodePrivacy"
                                 >确认提交</div>
                        </div>
                    </div>
                    <div v-show="popupVisible"
                         class="popResult">
                        <div class="popcon">
                            <div v-show="isSuccess"
                                 class="popSuccess">
                                <img src="https://resource.rcclchina.com.cn/42/mice/images/ok.png" />
                                <p>提交成功!</p>
                            </div>
                            <div v-show="!isSuccess"
                                 class="popFail">
                                <img src="https://resource.rcclchina.com.cn/42/mice/images/warn.png" />
                                <p class="ratext">{{ errorMessage }}</p>
                            </div>
                            <span class="popclose"
                                  @click="closePopup">关&nbsp;&nbsp;闭</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <common-confirm v-model="isVerificationCodeLayer"
                        :is-button="false"
                        title="安全验证"
                        width="90%">
            <div slot="content">
                <div class="verification-code"
                     id="captcha"></div>
            </div>
        </common-confirm>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import api from '@/api'
import { isEmpty } from "@/utilities/tools"
const CommonConfirm = () => import("@/components/Common/CommonConfirm");

export default {
    name: 'HomeTopic',
    components: {
        Swiper,
        SwiperSlide,
        CommonConfirm
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            isShowContact: false,
            banners: [
                require('@/assets/mice/homekv1.jpg'),
                require('@/assets/mice/homekv2.jpg'),
                require('@/assets/mice/homekv3.jpg'),
                require('@/assets/mice/homekv4.jpg'),
                require('@/assets/mice/homekv5.jpg'),
                require('@/assets/mice/homekv6.jpg'),
                require('@/assets/mice/homekv7.jpg'),
            ],
            swiperOptions: {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
            },
            shipSwiperOptions: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                slidesPerView: 1.5,
                spaceBetween: 25,
                centeredSlides:true	
            },
            isShowPlan: false,
            isShowVideo: false,
            formData: {
                companyName: '',
                contactName: '',
                contactTelephone: '',
                contactEmail: '',
                jobTitle: '',
                meetingDate: null,
                meetingDurationInNights: '',
                roomCount: '',
                meetingType: '',
                leadSource: '',
                desiredDestination: '',
                file: null, // 用于存储文件对象
                remark: '',
            },
            meetingTypeOptions: [
                { label: '请选择会议类型', value: '' },
                { label: '公司会议', value: '1' },
                { label: '公司奖励', value: '2' },
                { label: '个人奖励', value: '3' },
                { label: '其他', value: '4' },
            ],
            leadSourceOptions: [
                { label: '请选择来源', value: '' },
                { label: '会展', value: '1' },
                { label: '邮件', value: '2' },
                { label: '线上广告', value: '3' },
                { label: '线下广告', value: '4' },
                { label: '其他', value: '5' },
            ],
            isAgree: false,
            isSuccess: false,
            errorMessage: '',
            popupVisible: false,
            isShowShips: false,
            isVerificationCodeLayer: false,
            isAllowNvc: true,
            minDate:this.getToday(),
            captcha:null,
        }
    },
    beforeMount() {
        this.initAWSC();
    },
    methods: {
        getToday() {
			const today = new Date();
			const yyyy = today.getFullYear();
			const mm = String(today.getMonth() + 1).padStart(2, '0');
			const dd = String(today.getDate()).padStart(2, '0');
			return `${yyyy}-${mm}-${dd}`;
		},
        /**
             * 显示弹窗
             * @param {boolean} success - 是否成功
             * @param {string} message - 错误信息（失败时使用）
             */
        showPopup(success, message = '') {
            this.isSuccess = success
            this.errorMessage = message
            this.popupVisible = true
        },

        /**
         * 关闭弹窗
         */
        closePopup() {
            this.popupVisible = false
        },
        showPlan() {
            this.isShowPlan = true
            this.$nextTick(() => {
                document.querySelector('.popPlan').classList.add('show')
            })
        },
        hidePlan() {
            const popPlan = document.querySelector('.popPlan')
            popPlan.classList.remove('show')
            // 等待动画完成后再设置 isShowPlan = false
            setTimeout(() => {
                this.isShowPlan = false
            }, 300) // 动画持续时间
        },

        handleFileUpload(event) {
            const file = event.target.files[0]
            if (file) {
                this.formData.file = file
            }
        },
        getInstance(instance) {
      this.captcha = instance
    },
    fail(error) {
      console.error(error);
      this.isAllowNvc = false
    },
    async success(captchaVerifyParam) {
      console.log(captchaVerifyParam,'captchaVerifyParam');
      this.submitForm(captchaVerifyParam)
    },
        initAWSC() {
            if (!window.initAliyunCaptcha) return
            // window.AWSC.use("nvc", (state, module) => {
            //     // 初始化 调用module.init进行初始化
            //     window.nvc = module.init({
            //         appkey: "FFFF0N00000000009D85",
            //         scene: "nvc_message",
            //         renderTo: '#captcha',
            //         // test: module.TEST_NC_PASS,
            //         // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
            //         success: async (data) => {
            //             this.isVerificationCodeLayer = false;
            //             this.$loading.show();
            //             const verifyData = this.getVerifyData(data);
            //             await this.submitPartnerLeadForm(verifyData);
            //         },
            //         // 前端二次验证失败时触发该回调参数
            //         fail: (failCode) => {
            //             console.log('failCode', failCode);
            //             this.isAllowNvc = false;
            //         },
            //         // 前端二次验证加载异常时触发该回调参数。
            //         error: (errorCode) => {
            //             console.log('errorCode', errorCode);
            //             this.isAllowNvc = false;
            //         }
            //     });
            // });

            window.initAliyunCaptcha({
                // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
                SceneId: "5v4v21th",
                // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
                mode: "popup",
                // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
                element: "#captcha",
                // 触发验证码弹窗或无痕验证的元素
                button: "#sendCodePrivacy",
                // 验证码验证通过回调函数
                success: this.success,
                // 验证码验证不通过回调函数
                fail: this.fail,
                // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
                getInstance: this.getInstance,
                // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
                slideStyle: {
                    width: 260,
                    height: 40,
                },
                // ...其他参数，参考initAliyunCaptcha参数说明
                });
        },
        getVerifyData(codeValue) {
            return {
                codeType: 'AliYunAfsNvc',
                codeValue: codeValue,
                sceneId: '5v4v21th',
				captchaVerifyParam: codeValue,
            };
        },
        afsFailureHandler(code) {
            console.log('afsFailureHandler' + code)
            this.isVerificationCodeLayer = true;
            // 行为可疑，进入二次滑动验证
            if (code === 'NvcNc') {
                const ncoption = {
                    renderTo: "#captcha",
                }
                let childNodes = document.getElementById('captcha').childNodes;
                for (let i = 0; i < childNodes.length; i++) {
                    let childNode = childNodes[i];
                    childNode.parentElement.removeChild(childNode);
                }
                // 唤醒二次验证（滑动验证码）
                window.nvc.getNC(ncoption);
            } else if (code === 'Block') {
                // 返回block，禁止提交
                this.isAllowNvc = false
                this.$alert.show(
                    "网络错误，请刷新页面重试。"
                );
            }
        },
        async submitForm(captchaVerifyParam) {


            // 验证必填字段
            const requiredFields = [
                { field: 'companyName', label: '公司名称' },
                { field: 'contactName', label: '联系人' },
                { field: 'contactTelephone', label: '手机号' },
                { field: 'contactEmail', label: '邮箱' },
                { field: 'meetingDate', label: '活动日期' },
                { field: 'roomCount', label: '房间数量' }
            ]
            const emptyField = requiredFields.find((item) => isEmpty(this.formData[item.field]))
            if (emptyField) {
                this.showPopup(false, `请填写${emptyField.label}`)
                return this.initAWSC()
            }
            // 验证手机号格式
            const phoneRegex = /^1[3-9]\d{9}$/
            if (!phoneRegex.test(this.formData.contactTelephone)) {
                this.showPopup(false, '请输入正确的手机号码')
                return this.initAWSC()
            }
            // 验证邮箱格式
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.formData.contactEmail)) {
                this.showPopup(false, '请输入正确的邮箱地址')
                return this.initAWSC()
            }
            //活动日期不能小于当前日期
            if (new Date(this.formData.meetingDate) < new Date(this.minDate)) {
                this.showPopup(false, '活动日期不能小于当前日期')
                return this.initAWSC()
            }

            if (!this.isAgree) {
                this.showPopup(false, '请阅读并同意隐私政策！')
                return this.initAWSC()
            }

            this.isAllowNvc = true
            this.isVerificationCodeLayer = false;
            this.$loading.show();
             const verifyData = this.getVerifyData(captchaVerifyParam);
            await this.submitPartnerLeadForm(verifyData);

            // 人机验证
            // if (!window.nvc) return;
            // this.$loading.show();
            // window.nvc.getNVCValAsync(async (nvcVal) => {
            //     const verifyData = this.getVerifyData(nvcVal);
            //     await this.submitPartnerLeadForm(verifyData);
            // });
        },
        async submitPartnerLeadForm(verifyData) {
            try {
                if (!this.isAllowNvc) return;
                const formDataObj = new FormData()
                Object.keys(this.formData).forEach((key) => {
                    if (!isEmpty(this.formData[key])) {
                        formDataObj.append(key, this.formData[key])
                    }
                })
                const { codeType, codeValue,sceneId,captchaVerifyParam } = verifyData
                formDataObj.append('codeType', codeType)
                formDataObj.append('codeValue', codeValue)
                formDataObj.append('sceneId', sceneId)
                formDataObj.append('captchaVerifyParam', captchaVerifyParam)
                const { errMsg, success } = await api.page.partnerLead(formDataObj);
                this.$loading.hide();
                if (success) {
                    this.resetForm()
                    this.showPopup(true)
                    this.initAWSC()
                } else {
                    if (errMsg === 'NvcNc' || errMsg === 'Block') {
                        // this.afsFailureHandler(errMsg)
                    } else {
                        this.showPopup(false, errMsg);
                        this.initAWSC()
                    }
                }
            } catch (error) {
                this.showPopup(false, '提交失败，请稍后重试')
            }
        },
        resetForm() {
            this.formData = {
                companyName: '',
                contactName: '',
                contactTelephone: '',
                contactEmail: '',
                jobTitle: '',
                meetingDate: '',
                meetingDurationInNights: '',
                roomCount: '',
                meetingType: '',
                leadSource: '',
                desiredDestination: '',
                file: null, // 用于存储文件对象
                remark: '',
            }
            if (this.$refs.rfpFileInput) {
                this.$refs.rfpFileInput.value = '';
            }
        },
        handleSelect() {
            this.isAgree = !this.isAgree
        },
        scrolltoForm() {
            // 延迟执行滚动，确保DOM完全渲染
            const element = document.querySelector('.partner')
                if (element) {
                    const elementPosition = element.getBoundingClientRect().top
                    const offsetPosition = elementPosition + window.pageYOffset
                    window.scrollTo({
                        top: offsetPosition - 43.5,// 减去导航栏的高度
                        behavior: 'smooth',
                    })
            }
        },
        handleNumberInput(field) {
            const value = this.formData[field]
            if (value) {
                // 移除小数点和非数字字符
                let intValue = parseInt(value)
                // 确保是正整数
                if (intValue < 1 || isNaN(intValue)) {
                    intValue = 1
                }
                //限制最大值为999
                if (intValue > 999) {
                    intValue = 999
                }
                this.formData[field] = intValue
            }
        },
    },
}
</script>
<style>
#layout-header {
    display: none;
}

nav.home-bar-nav {
    display: none;
}

.footer-nav {
    display: none;
}

.main-content {
    margin-top: 0;
}
</style>
<style lang="less" scoped>
@import '../../styles/unit.less'; // 导入 unit.less 文件

::v-deep .swiper-pagination-bullet {
    background: #555763;
    opacity: 1;
}

::v-deep .swiper-pagination-bullet-active {
    background: #fbc500;
}

a,
img {
    border: 0;
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

.pr {
    position: relative;
}

.mice-page {
    background: #fff;
}

.popPlan {
    position: fixed;
    left: 100%; // 初始位置在屏幕右侧
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #fff;
    z-index: 999999;
    transition: left 0.3s ease;

    &.show {
        left: 0;
    }
}

.plan {
    padding: 30px 17.5px 0 17.5px;
    box-sizing: border-box;
    height: 90%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}

.popPlan h2 {
    font-size: 18px;
    color: #121920;
    font-weight: bold;
    margin-bottom: 10px;
}

.popPlan p {
    font-size: 12px;
    color: #121920;
    line-height: 20px;
    margin-bottom: 30px;
}

.popPlan p span {
    color: #fbc500;
}

.btn_back {
    width: 50px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}

.racontainer {
    width: 100%;
    padding-top: 43.5px;
}

.home {
    padding-bottom: 75px;
    box-sizing: border-box;
}

.headerer_ra {
    position: fixed;
    width: 100%;
    height: 43.5px;
    top: 0;
    left: 0;
    background-image: url('../../assets/mice/bglogo.png');
    background-color: #000;
    background-size: 100% 43.5px;
    background-repeat: no-repeat;
    z-index: 9999;
}

.headerer_ra a.link-home {
    position: absolute;
    left: 12px;
    top: 12px;
    width: 56px;
    height: 21px;
    line-height: 20px;
    border: 1px solid #fff;
    color: #fff;
    border-radius: 5px;
    text-align: center;
    font-size: 11px;
    display: block;
    text-decoration: none;
}

.quote {
    position: absolute;
    right: 69px;
    top: 14px;
    color: #fff;
    text-align: center;
    font-size: 11px;
}

.dailog {
    width: 54px;
    height: 19px;
    position: absolute;
    right: 12px;
    top: 12px;
}

.contact-text {
    padding-top: 1.5px;
    color: #fff;
    text-align: center;
    font-size: 11px;
}

.contact-pop {
    width: 121.5px;
    height: 57px;
    position: absolute;
    right: 0;
    top: 15px;
}

.contact-pop img {
    width: 100%;
}

.contact-pop .tel {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 60%;
}

.racontainer img {
    display: block;
    width: 100%;
}

.swiper-kv {
    width: 100%;
}

.kv .swiper-kv img {
    width: 100%;
    height: 264px;
}

.racontainer .home .kv {
    width: 100%;
    position: relative;
}

.swiper-kv2 {
    width: 100%;
    margin-top: 28.5px;
    margin-bottom: .rem2px(0.78) [ @return];
}

.swiper-kv2 .swiper-slide {
    width: .rem2px(5.33) [ @return];
}

.swiper-kv2 .swiper-slide-active {
    width: .rem2px(5.33) [ @return];
}

.swiper-kv2 .swiper-slide-prev {
    width: .rem2px(5.33) [ @return];
}

.swiper-kv2 .swiper-slide-next {
    width: .rem2px(5.33) [ @return];
}

.kv2 .swiper-slide a {
    position: absolute;
    display: inline-block;
    bottom: .rem2px(0.58) [ @return];
    left: 50%;
    transform: translateX(-50%);
    width: 75px;
    height: .rem2px(0.45) [ @return];
    font-size: 12px;
    background-color: #fbc500;
    text-align: center;
    line-height: .rem2px(0.45) [ @return];
    color: #fff;
    border-radius: .rem2px(0.04) [ @return];
}

.kv2 {
    position: relative;
}

.swiper-kv2 img {
    width: .rem2px(5.13) [ @return];
    height: .rem2px(5.08) [ @return];
    margin: 0 auto;
}

.racontainer .pagination-kv2 {
    left: 50%;
    transform: translateX(-50%);
    bottom: .rem2px(-0.55) [ @return];
}

.racontainer .pagination-kv2 .swiper-pagination-bullet {
    width: .rem2px(0.4) [ @return];
    height: .rem2px(0.06) [ @return];
    border-radius: 20px;
    opacity: 1;
    background: #0073bb;
    margin: 0 10px;
}

.racontainer .pagination-kv2 .swiper-pagination-bullet-active {
    background: #a3cde6;
}

.racontainer .home .videobox {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 158px;
}

.racontainer .home .videobox img {
    width: 100%;
    height: 158px;
}

.racontainer .home .btn_play,
.racontainer .home .myvideo {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 158px;
    background: #000;
    cursor: pointer;
}

.racontainer .home .myvideo {
    display: none;
    z-index: 6;
}

.racontainer .home .myvideo .video {
    width: 100%;
    display: block;
}

#thePlayer1_video {
    width: 100% !important;
}

.racontainer .home #thePlayer1 {
    margin: 0 auto;
}

.racontainer .home .txt {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 10px solid #f5f5f5;
}

.racontainer .home .txt div {
    padding: 12.5px 30px 12.5px 22.5px;
}

.popVideo {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
}

.popVideo video {
    width: 100%;
    height: auto;
}

.popVideo .content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
}

.popVideo .close {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    width: 6%;
}

.racontainer .home .txt h2 {
    font-size: 16px;
    color: #fbc500;
    line-height: 50px;
    font-weight: bold;
    margin-bottom: 2.5px;
}

.racontainer .home .txt p {
    font-size: 11px;
    color: #3f3f3f;
    line-height: 17.5px;
}

.pr {
    width: 100%;
}

.pr img {
    width: 100%;
}

.pr p {
    width: 100%;
    height: .rem2px(0.97) [ @return];
    position: relative;
    display: flex;
    align-items: center;
}

.pr p span {
    color: #fbc500;
    font-size: .rem2px(0.32) [ @return];
    line-height: .rem2px(0.97) [ @return];
    padding-left: .rem2px(0.54) [ @return];
    font-weight: bold;
    letter-spacing: .rem2px(0.02) [ @return];
}

.pr p a {
    display: inline-block;
    width: .rem2px(1.68) [ @return];
    height: .rem2px(0.67) [ @return];
    background-color: #3171b5;
    color: #ffffff;
    font-size: 15px;
    line-height: .rem2px(0.67) [ @return];
    text-align: center;
    position: absolute;
    right: 28.5px;
    top: 7.5px;
    letter-spacing: 1.5px;
    border-radius: 1.5px;
}

.racontainer .partner {
    width: 100%;
    position: relative;
    overflow-y: scroll;
}

.racontainer .partner .box {
    width: 100%;
}

.racontainer .partner .formlist {
    width: 100%;
    position: relative;
}

.racontainer .partner .formlist {
    color: #121920;
    padding: 19px .rem2px(0.58) [ @return] 0;
    box-sizing: border-box;
}

.racontainer .partner .formlist .group {
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    padding: 5px 0;
}

.racontainer .partner .formlist .group label {
    display: block;
    width: 80px;
    font-size: 14px;
    color: #000;
    margin-right: 4px;
    text-align: left;
    position: relative;
    .required{
        color: red;
        position: absolute;
        left: -8px;
        top: 0;
        font-size: 12px;
    }
}


.racontainer .partner .formlist .group input {
    width: 245px;
    outline: none;
    border: none;
    color: #acacac;
    font-size: 12px;
    line-height: 50px;
    height: 50px;
    background: #fff;

    &::placeholder {
        color: #acacac;
    }
}

.racontainer .partner .formlist .form-select {
    width: 245px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid transparent;
    background-color: #fff;
    height: 36px;
    box-sizing: border-box;
    color: #acacac;
    outline: none;
}

.racontainer .partner .formlist h2 {
    font-size: 24px;
    position: relative;
    letter-spacing: 1.5px;
}

.racontainer .partner .formlist .submit {
    background: #fbc200;
    text-align: center;
    font-size: .rem2px(0.32) [ @return];
    padding: 0;
    height: .rem2px(0.71) [ @return];
    line-height: .rem2px(0.71) [ @return];
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    margin-top: .rem2px(0.4) [ @return];
}

.racontainer .partner .formlist p {
    color: #121920;
    font-size: 14px;
    margin-top: 15px;
}

.racontainer .partner .formlist p.partTip {
    font-size: 12px;
    color: #3171b5;
    margin-top: 2.5px;
    letter-spacing: 0.5px;
}

.racontainer .partner .formlist p .checkbox {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    border: 1px solid #004ac5;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    cursor: pointer;
    position: relative;

    &.selected:after {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: #3171b5;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}

.racontainer .content2,
.racontainer .content1 {
    padding-bottom: 50px;
}

.bottomnav {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #f7f7f7;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
}

.bottomnav .nav:nth-of-type(1) {
    width: 42.5px;
}

.bottomnav .nav:nth-of-type(2) {
    width: 63.5px;
}

.bottomnav .nav:nth-of-type(3) {
    width: 42px;
}

.select {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    width: 138px;
    height: 100px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 50px;
    z-index: 99;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
}

.select div {
    width: 100%;
    color: #001849;
    font-size: 15px;
    text-align: center;
    height: 50px;
    box-sizing: border-box;
    line-height: 50px;
}

.select a {
    color: #001849;
    display: block;
    width: 100%;
}

.bottomnav .pos {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
}

.bottomnav .pos div {
    position: relative;
}

.bottomnav .nav .img {
    position: absolute;
    left: 0;
    top: 0;
    display: none;
}

.bottomnav .nav p {
    font-size: 10px;
    color: #979797;
}

.bottomnav .nav.active .img {
    display: block;
}

.bottomnav .nav.active p {
    color: #4a90e2;
}



.racontainer .partner .formlist p a {
    color: #3171b5;
    text-decoration: none;
}

.racontainer .partner .popResult {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    font-size: 18px;
    text-align: center;
    color: #121920;
    z-index: 33;
}

.racontainer .partner .popResult .popcon {
    width: 250px;
    height: 150px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}

.pos {
    position: relative;
}

.popcon .popSuccess,
.popFail {
    position: absolute;
    width: 80%;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}

.racontainer .partner .popResult .popcon img {
    display: inline-block;
    width: 31px;
    margin-bottom: 10px;
}

.racontainer .partner .popResult .popcon p {
    font-size: 12px;
    letter-spacing: 1px;
}

.racontainer .partner .popResult .popcon .popclose {
    width: 100%;
    height: 47px;
    line-height: 47px;
    background: #fbc200;
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
    font-size: 14px;
}

#captcha {
    position: relative;
    width: 300px;
    margin: 15px auto;

    .nc_wrapper {
        width: 100%;
    }
}
</style>
